import { create } from 'zustand';
import type { HelixMode } from '@design-system/theme/tokens';

export type SupportedLocale = 'en' | 'ar';

export const PORTAL_LANGUAGE_STORAGE_KEY = 'helix.portal.language';

function getStoredLocale(): SupportedLocale {
  if (typeof window === 'undefined') {
    return 'en';
  }

  try {
    return window.localStorage.getItem(PORTAL_LANGUAGE_STORAGE_KEY) === 'ar' ? 'ar' : 'en';
  } catch {
    return 'en';
  }
}

function storeLocale(locale: SupportedLocale) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(PORTAL_LANGUAGE_STORAGE_KEY, locale);
  } catch {
    // Keep the in-memory preference working when browser storage is unavailable.
  }
}

interface UiState {
  mode: HelixMode;
  locale: SupportedLocale;
  mobileNavigationOpen: boolean;
  toggleMode: () => void;
  setLocale: (locale: SupportedLocale) => void;
  setMobileNavigationOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  mode: 'light',
  locale: getStoredLocale(),
  mobileNavigationOpen: false,
  toggleMode: () => set((state) => ({ mode: state.mode === 'light' ? 'dark' : 'light' })),
  setLocale: (locale) => {
    storeLocale(locale);
    set({ locale });
  },
  setMobileNavigationOpen: (mobileNavigationOpen) => set({ mobileNavigationOpen }),
}));
